import { z } from 'zod';
export const siteSchema = z.object({
    id: z.uuid(),
    orgId: z.uuid(),
    name: z.string(),
    description: z.string().nullable(),
    /**
     * Шаг сетки на карте площадки, в пикселях.
     *
     * Хранится у площадки, а не у пользователя: сетка задаёт, куда встают
     * узлы, и разный шаг у двух инженеров даёт схему, которую они правят
     * по-разному — один выравнивает по восьми, второй по тридцати двум,
     * и после каждого правка второго выглядит съехавшей.
     */
    mapGrid: z.int(),
    createdAt: z.iso.datetime(),
});
export const createSiteSchema = z.object({
    name: z.string().trim().min(1).max(200),
    description: z.string().trim().max(2000).nullable().optional(),
    // Мельче четырёх пикселей сетка неразличима, крупнее ста двадцати восьми
    // на ней не разместить и десятка узлов.
    mapGrid: z.int().min(4).max(128).optional(),
});
export const updateSiteSchema = createSiteSchema.partial();
//# sourceMappingURL=sites.js.map